import EnFlag from '../../assets/en-gb.svg';
import NlFlag from '../../assets/nl.svg';
import DeFlag from '../../assets/de.svg';
import ItFlag from '../../assets/it.svg';
import FrFlag from '../../assets/fr.svg';
import { routePaths } from './globalConfig';

// ------------------- Language Options -------------------

/**
 *
 */
export const languageOptions = [
  {
    value: 'en',
    label: (
      <div>
        <img src={EnFlag} width="20px" height="20px" alt="" /> <div>EN</div>
      </div>
    ),
  },
  {
    value: 'nl',
    label: (
      <div>
        <img src={NlFlag} width="20px" height="20px" alt="" /> <div>NL</div>
      </div>
    ),
  },
  {
    value: 'de',
    label: (
      <div>
        <img src={DeFlag} width="20px" height="20px" alt="" /> <div>DE</div>
      </div>
    ),
  },
  {
    value: 'it',
    label: (
      <div>
        <img src={ItFlag} width="20px" height="20px" alt="" /> <div>IT</div>
      </div>
    ),
  },
  {
    value: 'fr',
    label: (
      <div>
        <img src={FrFlag} width="20px" height="20px" alt="" /> <div>FR</div>
      </div>
    ),
  },
];

/**
 *
 */
export const AdminLanguageOptions = [
  {
    value: 'en',
    label: (
      <div>
        <img src={EnFlag} width="20px" height="20px" alt="" /> <div>EN</div>
      </div>
    ),
  },
  {
    value: 'nl',
    label: (
      <div>
        <img src={NlFlag} width="20px" height="20px" alt="" /> <div>NL</div>
      </div>
    ),
  },
];

// ------------------- Admin Routes -------------------
/**
 *
 */
export const adminRoutes = [routePaths.invoiceList];

// ------------------- (Optionally: main app routes) -------------------
/**
 *
 */
export const mainRoutes = [
  routePaths.pro,
  routePaths.store,
  routePaths.maps,
  routePaths.transferApp,
  routePaths.projects,
  routePaths.mapsApp,
  // add any more routes you want here
];
